import { useState } from 'react';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import { ArrowRightIcon } from '@heroicons/react/24/outline';
import QuickLinks from '../components/faq/QuickLinks';
import FAQSection from '../components/faq/FAQSection';
import AdditionalResources from '../components/faq/AdditionalResources';
import { faqSections } from '../data/faq';

export default function Documentation() {
  const [openSection, setOpenSection] = useState<string | null>('getting-started');

  return (
    <>
      <Helmet>
        <title>RentFi | Frequently Asked Questions</title>
        <meta 
          name="description" 
          content="Get answers to common questions about RentFi's real estate investment platform. Learn about RENT tokens, monthly yields up to 12.88%, investment process, and how to start earning passive income." 
        />
        <meta 
          name="keywords" 
          content="RentFi FAQ, RENT token FAQ, real estate investment questions, passive income FAQ, blockchain real estate FAQ, property investment help" 
        />
        <link rel="canonical" href="https://rentfi.io/faq" />
      </Helmet>
      <div className="min-h-screen bg-gray-50 py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <div className="text-center mb-16">
              <h1 className="text-primary mb-4">Frequently Asked Questions</h1>
              <p className="text-body-large text-gray-600">
                Everything you need to know about RentFi
              </p>
            </div>

            <QuickLinks openSection={openSection} setOpenSection={setOpenSection} />

            <div className="space-y-6 mb-16">
              {faqSections.map((section) => (
                <FAQSection
                  key={section.id}
                  section={section}
                  isOpen={openSection === section.id}
                  onToggle={() => setOpenSection(openSection === section.id ? null : section.id)}
                />
              ))}
            </div>

            <div className="text-center mb-16">
              <a
                href="https://rentfi.crunch.help"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-cta inline-flex items-center justify-center px-8 py-4 text-lg group"
                aria-label="Access RentFi's comprehensive knowledge base for detailed guides and documentation"
              >
                Read our comprehensive Knowledge Base
                <ArrowRightIcon className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" />
              </a>
            </div>

            <AdditionalResources />
          </motion.div>
        </div>
      </div>
    </>
  );
}